import { render, staticRenderFns } from "./lvshi_add.vue?vue&type=template&id=38bc2b4c&scoped=true"
import script from "./lvshi_add.vue?vue&type=script&lang=js"
export * from "./lvshi_add.vue?vue&type=script&lang=js"
import style0 from "./lvshi_add.vue?vue&type=style&index=0&id=38bc2b4c&prod&scoped=true&lang=less"
import style1 from "./lvshi_add.vue?vue&type=style&index=1&id=38bc2b4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bc2b4c",
  null
  
)

export default component.exports